// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import DocumentMeta from 'react-document-meta'
import { withRouter, Switch, Route } from 'react-router-dom'

// Internal Dependencies:
// import PageData from 'containers/PageData'
// import { getUrlParameter } from 'utilities/url'
import SiteLayout from 'layouts/SiteLayout'

import Home from 'views/pages/Home'
import PageSections from 'components/PageSections/_PageSections'
import Honours from 'components/Honours/Honours'
import HonourTypes from 'components/Honours/HonourTypes'
import MasterHonours from 'components/Honours/MasterHonours'
import HonoursCategory from 'components/Honours/HonoursCategory'
import Activities from 'components/Activities/Activities'
import ActivitiesCategory from 'components/Activities/ActivitiesCategory'

import { get } from 'utilities/objects'

// Redux:
import { getScreenSize, setOnLineStatus, setConnectionStatus, setSiteLoaded } from 'actions/site'

class SiteContainer extends React.Component {
	componentDidMount() {
		this.update()

		// Device:
		window.addEventListener( 'resize', this.onResize )

		// Connection speed:
		this.nativeConnection = !! window.navigator.connection

		if ( this.nativeConnection ) {
			this.updateConnectionStatus()

			navigator.connection.addEventListener( 'onchange', this.updateConnectionStatus )
		}

		this.updateOnLineStatus()
		window.addEventListener( 'online', this.updateOnLineStatus )
		window.addEventListener( 'offline', this.updateOnLineStatus )

		setTimeout( () => {
			this.props.dispatch( setSiteLoaded() )
		}, ( siteData.loading_delay_seconds * 1000 ) + 3000 )
	}

	componentWillUnmount() {
		// Device:
		window.removeEventListener( 'resize', this.onResize )

		// Connection speed:
		if ( this.nativeConnection ) {
			navigator.connection.removeEventListener( 'onchange', this.updateConnectionStatus )
		}

		window.removeEventListener( 'online', this.updateOnLineStatus )
		window.removeEventListener( 'offline', this.updateOnLineStatus )
	}

	componentDidUpdate( prevProps ) {
		this.update()
	}

	update = () => {
		// Page data used by DK Editor:
		const { dkePageData } = this.props
		const dkePageDataJson = JSON.stringify( dkePageData )

		document.body.setAttribute( 'data-dke-page-data', dkePageDataJson )
	}

	onResize = () => {
		this.props.dispatch( getScreenSize() )
	}

	updateConnectionStatus = () => {
		if ( ! navigator.onLine ) {
			return
		}

		const { dispatch } = this.props

		dispatch( setConnectionStatus( {
			effectiveType: navigator.connection.effectiveType,
			downlink: navigator.connection.downlink,
			rtt: navigator.connection.rtt
		} ) )
	}

	updateOnLineStatus = () => {
		const { dispatch } = this.props

		dispatch( setOnLineStatus( navigator.onLine ) )
	}

	render() {
		const meta = {
			title: siteData.site_name
		}

		return [
			<DocumentMeta { ...meta } key="DocumentMeta" />,

			<Switch key="Switch">
				<Route path="/" exact render={ props => (
					<SiteLayout type="page" { ...props }>
						<Home { ...props } />
					</SiteLayout>
				) } />

				{/* Honours */}
				<Route path="/honour-types" exact render={ props => (
					<SiteLayout type="honour-types" { ...props }>
						<HonourTypes { ...props } />
					</SiteLayout>
				) } />

					<Route path="/honours" exact render={ props => (
						<SiteLayout type="honours" { ...props }>
							<Honours { ...props } />
						</SiteLayout>
					) } />

					<Route path="/master-honours" exact render={ props => (
						<SiteLayout type="master-honours" { ...props }>
							<MasterHonours { ...props } />
						</SiteLayout>
					) } />

					<Route path="/new-honours" exact render={ props => (
						<SiteLayout type="new-honours" { ...props }>
							<MasterHonours { ...props } />
						</SiteLayout>
					) } />

					<Route path="/revised-honours" exact render={ props => (
						<SiteLayout type="revised-honours" { ...props }>
							<MasterHonours { ...props } />
						</SiteLayout>
					) } />

					{/* Honours - category */}
					<Route path="/honours/category/:slug" exact render={ props => (
						<SiteLayout type="honours-category" { ...props }>
							<HonoursCategory { ...props } />
						</SiteLayout>
					) } />

					{/* Honours - single */}
					<Route path="/honour/:slug" exact render={ props => (
						<SiteLayout type="honour" { ...props }>
							<PageSections { ...props } />
						</SiteLayout>
					) } />

				{/* Activities */}
				<Route path="/activities" exact render={ props => (
					<SiteLayout type="activities" { ...props }>
						<Activities { ...props } />
					</SiteLayout>
				) } />

					{/* Activities - category */}
					<Route path="/activities/category/:slug" exact render={ props => (
						<SiteLayout type="activities-category" { ...props }>
							<ActivitiesCategory { ...props } />
						</SiteLayout>
					) } />

					{/* Activities - single */}
					<Route path="/activity/:slug" exact render={ props => (
						<SiteLayout type="activity" { ...props }>
							<PageSections { ...props } />
						</SiteLayout>
					) } />

				<Route path="/:slug/page/:archivePageNumber" exact render={ props => (
					<SiteLayout type="page" { ...props }>
						<PageSections { ...props } />
					</SiteLayout>
				) } />

				<Route path="/:slug" exact render={ props => (
					<SiteLayout type="page" { ...props }>
						<PageSections { ...props } />
					</SiteLayout>
				) } />

				<Route path="/:parentSlug/:slug" exact render={ props => (
					<SiteLayout type="page" { ...props }>
						<PageSections { ...props } />
					</SiteLayout>
				) } />
			</Switch>
		]
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		dkePageData: state.page.dkePageData
	}
}

export default withRouter(
	connect( mapStateToProps )( SiteContainer )
)



// WEBPACK FOOTER //
// ./containers/SiteContainer.jsx